import React from 'react'
import { useTranslate, required, Form } from 'react-admin'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import SaveIcon from '@mui/icons-material/Save'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
  DialogActions,
} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'

export const PricingPassengerModal = ({
  open,
  handleClose,
  titleModal,
  onSubmit,
  loadingButton
}) => {
  const translate = useTranslate()
  const postSave = (data) => {
    onSubmit && onSubmit(data)
  }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.comision')}>
              <NumberInput
                source='pricing.comision'
                label=''
                defaultValue={0}
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.commission_paid')}>
              <NumberInput
                source='pricing.commission_paid'
                label=''
                fullWidth
                thousandSeparator='.'
                defaultValue={0}
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.commission_percentage')}>
              <NumberInput
                source='pricing.commission_percentage'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.iva')}>
              <NumberInput
                source='pricing.iva'
                label=''
                defaultValue={0}
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.fare_amount')}>
              <NumberInput
                source='pricing.fare_amount'
                label=''
                defaultValue={0}
                fullWidth
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.over_amount')}>
              <NumberInput
                source='pricing.over_amount'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.taxes_amount')}>
              <NumberInput
                source='pricing.taxes_amount'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.taxes_1')}>
              <NumberInput
                source='pricing.taxes_1'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.taxes_2')}>
              <NumberInput
                source='pricing.taxes_2'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.taxes_3')}>
              <NumberInput
                source='pricing.taxes_3'
                label=''
                fullWidth
                defaultValue={0}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
              />
            </EditInputsWrap>
          </Grid>
        </Form>
      </DialogContent>
      <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
        <LoadingButton
          loading={loadingButton}
          variant='contained'
          startIcon={<SaveIcon />}
          form='post_create_form'
          type='submit'
        >
          {translate('ra.action.save_and_recalculate_liquidation')}
        </LoadingButton>
        <Button onClick={handleClose} variant='outlined' color='error'>
          {translate('ra.action.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

